// extracted by mini-css-extract-plugin
export var alertIcon = "_rx-0";